import {
  HOME_SCENE_1,
  HOME_SCENE_2,
  HOME_SCENE_3,
  HOME_SCENE_4,
  HOME_SCENE_5,
  HOME_SCENE_6,
  HOME_SCENE_7,
} from "./index";

export const PHYSICIAN_LANDING_DATA = [
  {
    title: "FLEXIBLE SCHEDULING",
    description:
      "See your own patient easily and conveniently during or outside office hrs.",
    image: HOME_SCENE_2,
  },
  {
    title: "APP CUSTOMIZATION",
    description:
      "Customize the app with your own logo and name of the practice.",
    image: HOME_SCENE_4,
  },
  {
    title: "VIDEO/TELE-CONFERENCE",
    description: "Video/ Tele conferencing",
    image: HOME_SCENE_6,
  },
  {
    title: "E-PRESCRIBE",
    description:
      "Send e prescription straight to your patient's local pharmacy",
    image: HOME_SCENE_1,
  },
  {
    title: "MEDICAL HISTORY",
    description:
      "Continuity of care: Able to download your patient visit and put in the chart.",
    image: HOME_SCENE_3,
  },
  {
    title: "PRO-BONO SERVICES",
    description:
      "It provides you to with the opportunity to offer pro-bono services",
    image: HOME_SCENE_5,
  },
  {
    title: "TRANSPARENT BILLING",
    description:
      "Set your price and reduce the cost of no shows and cancellations.",
    image: HOME_SCENE_7,
  },
];

export const PATIENT_LANDING_DATA = [
  {
    title: "FLEXIBLE SCHEDULING",
    description:
      "Choose and consult with your own preferred provider and physician that is in your local area, along with the network of available physicians.",
    image: HOME_SCENE_1,
  },
  {
    title: "ADD DEPENDENTS",
    description:
      "Add family members dependents or seniors, for which you have medical power of attorney, to your account so they can see their physicians too.",
    image: HOME_SCENE_2,
  },
  {
    title: "E-PRESCRIBE",
    description: "Prescriptions can be sent to preferred pharmacies. ",
    image: HOME_SCENE_3,
  },
  {
    title: "QUALIFIED PHYSICIANS",
    description: "Ask for second opinions.",
    image: HOME_SCENE_4,
  },
  {
    title: "LOCAL ACCESS",
    description:
      "See which providers are available outside of office hours to prevent going to the urgent care or ER visit.",
    image: HOME_SCENE_5,
  },
  {
    title: "VIDEO/TELE-CONFERENCE",
    description:
      "Real-time, video-conference or tele-conference capabilities with option to make scheduled appointments",
    image: HOME_SCENE_6,
  },
  {
    title: "MEDICAL HISTORY",
    description: "Download your visit summary",
    image: HOME_SCENE_7,
  },
];
